import React, { useRef, useEffect, useState } from 'react';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import deleteSVG from '../../assets/images/delete.svg';


function updateJson(jsonData, path, newValue, ind) {
  if (ind == path.length)
    return newValue
  jsonData[path[ind]] = updateJson(jsonData[path[ind]], path, newValue, ind+1)
  return jsonData
}

const NewConfigSelect = ({
  options=[],
  jsonSchema={},
  path=[],
  lookerConfigDataState={},
  setLookerConfigDataState=()=>{}
}) => {

  const [selectValue, setSelectValue] = useState(null)

  return (
    <div className='flex border-b-2 border-gray-200'>
      <div className="w-full flex p-3">
        <Select
          className="max-w-md w-full mr-3"
          options={options}
          onChange={(value) => {
            setSelectValue(value.value)
          }}

        />
        <button 
          className="bg-indigo-600 rounded-md text-white break-keep p-2"
          onClick={(e) => {
            e.preventDefault()

            if (selectValue != null) {

              var defaultdata=""
              switch (jsonSchema['properties'][selectValue]['type']) {
                case "array":
                  defaultdata = []
                  break;
                case "object":
                  defaultdata = {}
                  break;
                case "boolean":
                  defaultdata = true
                  break;
              }

              var currentPathData = lookerConfigDataState
              path.map((val) => {currentPathData = currentPathData[val]})

              if (!(selectValue in currentPathData)) {
                setLookerConfigDataState(
                  {...updateJson(lookerConfigDataState, [...path, selectValue], defaultdata, 0)}
                )
              }
            }
          }}

        >Add Config</button>
      </div>
    </div>
  )
}

function deleteKey(lookerConfigDataState={}, setLookerConfigDataState=()=>{}, path=[], delkey=null) {
  var parentNode = { ...lookerConfigDataState };
  path.forEach(step => {parentNode=parentNode[step]});

  var newValue=Object.keys(parentNode)
  .filter((key) => key != delkey)
  .reduce((result, key) => {
    result[key] = parentNode[key];
    return result;
  }, {});

  setLookerConfigDataState(
    {...updateJson(lookerConfigDataState, path, newValue, 0)}
  )
}

const ConfigElement = ({
  val=null,
  delBtn=true,
  lookerConfigDataState={}, 
  setLookerConfigDataState=()=>{}, 
  path=[],
  editElement=<></>
}) => {
  return (
    <div className='flex border-b-2 border-gray-200'>
      <div className="w-2/6 flex justify-between border-r-2 border-gray-200 p-3">
        <div className='break-all mr-3'>{val}</div>
        <div className="w-3.5 min-w-max">
          {
            (delBtn) &&
            <button 
              className="w-3.5 min-w-max"
              onClick={(e) => {
                e.preventDefault()
                deleteKey(lookerConfigDataState, setLookerConfigDataState, path, val)
              }}
            ><img className="w-3.5 min-w-max" src={deleteSVG} alt="Delete"/></button>
          }
        </div>
      </div>
      <div className='w-4/6'>
        {editElement}
      </div>
    </div>
  )
}

const LookerConfigEditForm = ({
    lookerConfigData={},
    lookerConfigschema={}
}) => {
  const [lookerConfigDataState, setLookerConfigDataState] = useState(lookerConfigData)
  const dataInputRef = useRef()

  useEffect(() => {
    dataInputRef.current.value = JSON.stringify(lookerConfigDataState)
  }, [lookerConfigDataState])

  return (
    <>

      <div className="border border-gray-200 m-4 mb-8">
        {
          ["enabled", "scorecardOnlyAccess"].map(val => (
            (val in lookerConfigDataState) && 
            <ConfigElement 
              val={val}
              delBtn={
                (!('required' in lookerConfigschema && lookerConfigschema['required'].includes(val)))
              }
              lookerConfigDataState={lookerConfigDataState}
              setLookerConfigDataState={setLookerConfigDataState} 
              path={[]}
              editElement={
                <div className='px-4 py-3 h-full flex items-center'>
                  <input
                    type="checkbox"
                    className='max-w-md'
                    defaultChecked={lookerConfigDataState[val]}
                    onChange={(e) => {
                      setLookerConfigDataState({...updateJson(lookerConfigDataState, [val], e.target.checked, 0)})
                    }}
                  />
                </div>
              }
            />           
          )) 
        }

        {
          ["scorecardModelId", "scorecardView", "scorecardCounterKey"].map(val => (
            (val in lookerConfigDataState) && 
            <ConfigElement 
              val={val}
              delBtn={
                (!('required' in lookerConfigschema && lookerConfigschema['required'].includes(val)))
              }
              lookerConfigDataState={lookerConfigDataState}
              setLookerConfigDataState={setLookerConfigDataState} 
              path={[]}
              editElement={
                <div className='px-4 py-3 h-full flex items-center'>
                  <input type="text"
                    className='border border-gray-200 w-full p-2 max-w-md'
                    defaultValue={lookerConfigDataState[val]}
                    onChange={(e) => {
                      setLookerConfigDataState({...updateJson(lookerConfigDataState, [val], e.target.value, 0)})
                    }}
                  />
                </div>
              }
            />
          )) 
        }

        {
          ["dashboards", "models"].map(val => (
            (val in lookerConfigDataState) && 
            <ConfigElement 
              val={val}
              delBtn={
                (!('required' in lookerConfigschema && lookerConfigschema['required'].includes(val)))
              }
              lookerConfigDataState={lookerConfigDataState}
              setLookerConfigDataState={setLookerConfigDataState} 
              path={[]}
              editElement={

                <div className='px-4 py-3 h-full flex items-center'>
                  <Select
                    className="max-w-md w-full"
                    isMulti={true}
                    defaultValue={   
                      (lookerConfigDataState[val] ?? []).map( item => {
                        var opt = lookerConfigschema['properties'][val]['enum'].find(opt => opt.value==item)
                        if (opt == undefined || opt == null)
                          return ({'label': item, 'value': item})
                        else
                          return ({"label": `${opt.value} - ${opt.label}`, "value": opt.value})
                      }) ?? []
                    }
                    options={
                      (() => {
                        var enumOptions = (lookerConfigschema?.['properties']?.[val]?.['enum'] ?? []).map( item => ({"label": `${item.value} - ${item.label}`, "value": item.value})) ?? []
                        var defaultOptions = (lookerConfigschema?.['properties']?.[val]?.['defaultOptions'] ?? []).map( item => ({"label": `${item} - ${item}`, "value": item})) ?? []

                        return [...defaultOptions, ...enumOptions]

                      })()
                    }
                    onChange={(value) => {
                      setLookerConfigDataState( {...updateJson(lookerConfigDataState, [val], value.map(item => item.value), 0)} )
                    }}
                  />
                </div>
              }
            />
          )) 
        }

        {
          ["Market"].map(val => (
            (val in lookerConfigDataState) && 
            <ConfigElement 
              val={val}
              delBtn={
                (!('required' in lookerConfigschema && lookerConfigschema['required'].includes(val)))
              }
              lookerConfigDataState={lookerConfigDataState}
              setLookerConfigDataState={setLookerConfigDataState} 
              path={[]}
              editElement={

                <div className='px-4 py-3 h-full flex items-center'>
                  <Select
                    className="max-w-md w-full"
                    isMulti={true}
                    defaultValue={   
                      (lookerConfigDataState[val] ?? []).map( item => {
                        var opt = lookerConfigschema['properties'][val]['enum'].find(opt => opt.value==item)
                        if (opt == undefined || opt == null)
                          return ({'label': item, 'value': item})
                        else
                          return ({"label": opt.label, "value": opt.value})
                      }) ?? []
                    }
                    options={
                      (lookerConfigschema?.['properties']?.[val]?.['enum'] ?? [])
                      .map( item => ({"label": item.label, "value": item.value})) ?? []
                    }
                    onChange={(value) => {
                      setLookerConfigDataState( {...updateJson(lookerConfigDataState, [val], value.map(item => item.value), 0)} )
                    }}
                  />
                </div>
              }
            />
          ))
        }

        {
          ["scorecardFields", "group_ids"].map(val => (
            (val in lookerConfigDataState) && 
            <ConfigElement
              val={val}
              delBtn={(!('required' in lookerConfigschema && lookerConfigschema['required'].includes(val)))}
              lookerConfigDataState={lookerConfigDataState}
              setLookerConfigDataState={setLookerConfigDataState} 
              path={[]}
              editElement={
                <div className='px-4 py-3 h-full flex items-center'>
                  <CreatableSelect
                    className="max-w-md w-full"
                    defaultValue={   
                      (lookerConfigDataState[val] ?? []).map( item => {
                        return ({'label': item, 'value': item})
                      }) ?? []
                    }
                    isMulti={true}
                    onChange={(value) => {
                      setLookerConfigDataState( {...updateJson(lookerConfigDataState, [val], value.map(item => item.value), 0)} )
                    }}
                    placeholder={<div>Create</div>}
                    components={
                      {Menu: (props) => {return null;}}                      
                    }
                  />
                </div>
              }
            />
          )) 
        }

        {
          ["defaultFilters"].map(val => (
            (val in lookerConfigDataState) && 
            <ConfigElement 
              val={val}
              delBtn={(!('required' in lookerConfigschema && lookerConfigschema['required'].includes(val)))}
              lookerConfigDataState={lookerConfigDataState}
              setLookerConfigDataState={setLookerConfigDataState} 
              path={[]}
              editElement={
                <>
                  {
                    ["Trated","Walmart Week","Assortment"].map(item => (
                      (val in lookerConfigDataState && item in lookerConfigDataState[val]) &&
                      <ConfigElement
                        val={item}
                        delBtn={(!('required' in lookerConfigschema['properties'][val] && lookerConfigschema['properties'][val]['required'].includes(item)))}                    
                        lookerConfigDataState={lookerConfigDataState}
                        setLookerConfigDataState={setLookerConfigDataState} 
                        path={[val]}
                        editElement={

                          <div className='px-4 py-3 h-full flex items-center'>
                            <input type="text"
                              className='border border-gray-200 w-full p-2 max-w-md'
                              defaultValue={lookerConfigDataState[val][item]}
                              onChange={(e) => {
                                setLookerConfigDataState({...updateJson(lookerConfigDataState, [val, item], e.target.value, 0)})                        
                              }}
                            />
                          </div>
                        }
                      />
                    ))
                  }

                  {
                    ["Channel"].map(item => (
                      (val in lookerConfigDataState && item in lookerConfigDataState[val]) &&
                      <ConfigElement
                        val={item}
                        delBtn={(!('required' in lookerConfigschema['properties'][val] && lookerConfigschema['properties'][val]['required'].includes(item)))}          
                        lookerConfigDataState={lookerConfigDataState}
                        setLookerConfigDataState={setLookerConfigDataState} 
                        path={[val]}
                        editElement={

                          <div className='px-4 py-3 h-full flex items-center'>
                            <Select
                              className="max-w-md w-full"
                              isMulti={false}
                              defaultValue={
                                [{label: lookerConfigDataState[val][item]?.[val]?.[item], value: lookerConfigDataState[val][item]?.[val]?.[item]}]
                              }
                              options={
                                lookerConfigschema?.['properties']?.[val]?.['properties']?.[item]?.['enum'] ?? []
                              }
                              onChange={(value) => {
                                setLookerConfigDataState( {...updateJson(lookerConfigDataState, [val, item], value.value, 0)} )
                              }}
                            />
                          </div>
                        }
                      />
                      
                    ))
                  }

                  {
                    ["Market","Region","Organisation","Brand","Retailer","Category","Client","Client Name","Assortment Group","SKU Group","Keyword Group"].map(item => (
                      (val in lookerConfigDataState && item in lookerConfigDataState[val]) &&
                      <ConfigElement
                        val={item}
                        delBtn={(!('required' in lookerConfigschema['properties'][val] && lookerConfigschema['properties'][val]['required'].includes(item)))}          
                        lookerConfigDataState={lookerConfigDataState}
                        setLookerConfigDataState={setLookerConfigDataState} 
                        path={[val]}
                        editElement={

                          <div className='px-4 py-3 h-full flex items-center'>
                            <Select
                              className="max-w-md w-full"
                              isMulti={true}
                              defaultValue={   
                                (lookerConfigDataState?.[val]?.[item] ?? []).map( valItem => {
                                  var opt = lookerConfigschema['properties'][val]['properties'][item]['enum'].find(opt => opt.value==valItem)
                                  if (opt == undefined || opt == null)
                                    return ({'label': valItem, 'value': valItem})
                                  else
                                    return ({"label": opt.label, "value": opt.value})
                                }) ?? []
                              }
                              options={

                                (() => {
                                  var enumOptions = (lookerConfigschema?.['properties']?.[val]?.['properties']?.[item]?.['enum'] ?? []).map( valItem => ({"label": valItem.label, "value": valItem.value})) ?? []
                                  var defaultOptions = (lookerConfigschema?.['properties']?.[val]?.['properties']?.[item]?.['defaultOptions'] ?? []).map( valItem => ({"label": valItem, "value": valItem})) ?? []

                                  return [...defaultOptions, ...enumOptions]
                                })()
                              }
                              onChange={(value) => {
                                setLookerConfigDataState( {...updateJson(lookerConfigDataState, [val, item], value.map(itemVal => itemVal.value), 0)} )
                              }}
                            />
                          </div>
                        }
                      />
                    ))
                  }

                  <NewConfigSelect
                    options={
                      Object.keys(lookerConfigschema['properties'][val]['properties']).map((item) => ({label: item, value: item}))
                    } 
                    jsonSchema={lookerConfigschema['properties'][val]}
                    path={[val]}
                    lookerConfigDataState={lookerConfigDataState}
                    setLookerConfigDataState={setLookerConfigDataState}
                  />
                </>
              }
            />

          ))
        }

        <NewConfigSelect
          options={
            Object.keys(lookerConfigschema['properties']).map((item) => ({label: item, value: item}))
          } 
          path={[]}
          jsonSchema={lookerConfigschema}
          lookerConfigDataState={lookerConfigDataState}
          setLookerConfigDataState={setLookerConfigDataState}
        />

      </div>

      <input 
        ref={dataInputRef}
        type="hidden" 
        name="looker_config[data]" 
        id="looker_config_data"
      />
    </>
    )
}

export default LookerConfigEditForm;